import api from "!../../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../node_modules/css-loader/dist/cjs.js!../../../../../../node_modules/less-loader/dist/cjs.js?{\"lessOptions\":{\"modifyVars\":{\"breadcrumb-last-item-color\":\"#333\",\"card-padding-base\":\"16px\",\"modal-footer-bg\":\"#f9f9f9\",\"modal-header-bg\":\"#f9f9f9\",\"table-row-hover-bg\":\"#f7fcff\"},\"javascriptEnabled\":true}}!./solution.less";

var options = {"injectType":"singletonStyleTag"};

options.insert = "head";
options.singleton = true;

var update = api(content, options);



export default content.locals || {};